import { ArchivedAPIresendAccessLinkRequestBody, BaseRequestBody, commonDocumentIdQueryRequestParameter, GetArchivedSignatureRequestParameter, GetDeliveredSignatureRequestParameter, GetDraftSignatureRequestParameter, GetSignerDetailRequestParameter, RecycleBinRequestParameter, SendForSignatureRequestBody, SendForSignatureWithTextIdRequestBody, SIG_ARCHIVED_GetAccessLinkRequestParameter, SIG_Delivered_ResendAccessLinkRequestBody, SIGBaseRequestBody, SignatureStatusRequestBody, UploadAPIsetAccessRequestBody } from "../../common/model/sig/requestBody"
import { GetAccessLinkResponseBody, GetArchivedSignatureResponseBody, GetDeliveredSignatureResponseBody, GetDraftSignatureResponseBody, GetRecycleBinResponseBody, GetSignatureStatusResponseBody, GetSignerDetailsResponseBody, SIG_ARCHIVED_GetAccessLinkResponseBody } from "../../common/model/sig/responseBody"
import { SIG_ArchivedSignatures_GetAccessLinkParameter, SIG_ArchivedSignatures_ArchivedSignaturesParameter, SIG_ArchivedSignatures_SendReminderParameter, SIG_ArchivedSignatures_SignerDetailsParameter, SIG_DeliveredAPI_AccessLinkParameter, SIG_DeliveredAPI_DeliveredSignaturesParameter, SIG_DeliveredAPI_ResendAccessLinkParameter, SIG_DeliveredAPI_SignerDetailsParameter, SIG_DraftAPI_DraftSignaturesParameter, SIG_RecycleBinApi_RecycleBinSignatureParameter, SIG_StatusApi_SignatureStatusParameter, SIG_UploadApi_SendForSignature_WithTextIdParameter, SIG_UploadApi_SendForSignatureParameter, SIG_UploadApi_SignatureStatusParameter, SIG_UploadApis_SetAccessParameter, sigBaseRequestBodyParameter } from "../apiParameters"
import { baseResponseBody } from "../objectTypeConstants"

export const sigBaseRequestBody: SIGBaseRequestBody = {
  requiredDocumentId: sigBaseRequestBodyParameter.requiredDocumentId,
  requiredCorrelationId: sigBaseRequestBodyParameter.requiredCorrelationID,
  callbackUri: sigBaseRequestBodyParameter.callbackUri,
}

export const uploadAPIsetAccessRequestBody: UploadAPIsetAccessRequestBody = {
  documentId: SIG_UploadApis_SetAccessParameter.documentId,
  correlationId: SIG_UploadApis_SetAccessParameter.correlationId,
  userIds: SIG_UploadApis_SetAccessParameter.userIds
}

export const getDraftSignatureRequestParameter: GetDraftSignatureRequestParameter = {
  nameQuery: SIG_DraftAPI_DraftSignaturesParameter.nameQuery,
  clientIdQuery: SIG_DraftAPI_DraftSignaturesParameter.clientIdQuery,
  assignedToQuery: SIG_DraftAPI_DraftSignaturesParameter.assignedToQuery,
  uploadedAfterDateQuery: SIG_DraftAPI_DraftSignaturesParameter.uploadedAfterDateQuery,
  documentTypeQuery: SIG_DraftAPI_DraftSignaturesParameter.documentTypeQuery,
  taxYearQuery: SIG_DraftAPI_DraftSignaturesParameter.taxYearQuery,
  pageSizeQuery: SIG_DraftAPI_DraftSignaturesParameter.pageSizeQuery,
  pageNumberQuery: SIG_DraftAPI_DraftSignaturesParameter.pageNumberQuery,
  sortOrderQuery: SIG_DraftAPI_DraftSignaturesParameter.sortOrderQuery,
  sortByQuery: SIG_DraftAPI_DraftSignaturesParameter.sortByQuery,
}

export const getDraftSignatureResponseBody: GetDraftSignatureResponseBody = {
  ...baseResponseBody,
  data: {
    name: SIG_DraftAPI_DraftSignaturesParameter.name,
    clientId: SIG_DraftAPI_DraftSignaturesParameter.clientId,
    assignedTo: SIG_DraftAPI_DraftSignaturesParameter.assignedTo,
    SignatureDocumentType: SIG_DraftAPI_DraftSignaturesParameter.SignatureDocumentType,
    uploadedAfterDate: SIG_DraftAPI_DraftSignaturesParameter.uploadedAfterDate,
    taxYear: SIG_DraftAPI_DraftSignaturesParameter.taxYear,
    signatureStatus: SIG_DraftAPI_DraftSignaturesParameter.signatureStatus,
    documentId: SIG_DraftAPI_DraftSignaturesParameter.documentId,
    documentName: SIG_DraftAPI_DraftSignaturesParameter.documentName,
    documentType: SIG_DraftAPI_DraftSignaturesParameter.documentType,
    expiresOn: SIG_DraftAPI_DraftSignaturesParameter.expiresOn,
    recipients: SIG_DraftAPI_DraftSignaturesParameter.recipients,
    subject: SIG_DraftAPI_DraftSignaturesParameter.subject,
    expiryDate: SIG_DraftAPI_DraftSignaturesParameter.expiryDate,
    locationId: SIG_DraftAPI_DraftSignaturesParameter.locationId
  }
}

export const SIG_DeliveredAPI_ResendAccessLinkRequestBody: SIG_Delivered_ResendAccessLinkRequestBody = {
  documentId: sigBaseRequestBody.requiredDocumentId,
  correlationId: sigBaseRequestBody.requiredCorrelationId,
  clientGuid: SIG_DeliveredAPI_ResendAccessLinkParameter.clientGuid
}

export const recycleBinRequestParameter: RecycleBinRequestParameter = {
  clientNameQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.clientNameQuery,
  clientIdQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.clientIdQuery,
  subjectQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.subjectQuery,
  documentTypeQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.documentTypeQuery,
  taxYearQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.taxYearQuery,
  recipientsQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.recipientsQuery,
  statusQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.statusQuery,
  deletedByQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.deletedByQuery,
  deletionDataQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.deletionDateQuery,
  sortByQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.sortByQuery,
  sortOrderQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.sortOrderQuery,
  pageNumberQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.pageNumberQuery,
  pageSizeQuery: SIG_RecycleBinApi_RecycleBinSignatureParameter.pageSizeQuery,
}

export const sendReminderRequestBody: BaseRequestBody = {
  requiredDocumentId: SIG_ArchivedSignatures_SendReminderParameter.requiredDocumentId,
  requiredCorrelationId: SIG_ArchivedSignatures_SendReminderParameter.requiredCorrelationID,
}

export const getDeliveredSignatureRequestParameter: GetDeliveredSignatureRequestParameter = {
  clientIdQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.clientIdQuery,
  clientNameQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.clientNameQuery,
  subjectQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.subjectQuery,
  sentByQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.sentByQuery,
  documentNameQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.documentNameQuery,
  documentTypeQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.documentTypeQuery,
  taxYearQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.taxYearQuery,
  deliveredDateQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.deliveredDateQuery,
  recipientQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.recipientQuery,
  signatureStatusQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.signatureStatusQuery,
  expiryDateQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.expiryDateQuery,
  LastReminderDateQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.lastReminderDateQuery,
  sortByQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.sortByQuery,
  sortOrderQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.sortOrderQuery,
  pageSizeQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.pageSizeQuery,
  pageNumberQuery: SIG_DeliveredAPI_DeliveredSignaturesParameter.pageNumberQuery,
}

export const getDeliveredSignatureResponseBody: GetDeliveredSignatureResponseBody = {
  ...baseResponseBody,
  data: {
    clientId: SIG_DeliveredAPI_DeliveredSignaturesParameter.clientId,
    clientName: SIG_DeliveredAPI_DeliveredSignaturesParameter.clientName,
    subject: SIG_DeliveredAPI_DeliveredSignaturesParameter.subject,
    sentBy: SIG_DeliveredAPI_DeliveredSignaturesParameter.sentBy,
    documentId: SIG_DeliveredAPI_DeliveredSignaturesParameter.documentId,
    documentName: SIG_DeliveredAPI_DeliveredSignaturesParameter.documentName,
    documentType: SIG_DeliveredAPI_DeliveredSignaturesParameter.documentType,
    expiresOn: SIG_DeliveredAPI_DeliveredSignaturesParameter.expiresOn,
    taxYear: SIG_DeliveredAPI_DeliveredSignaturesParameter.taxYear,
    recipients: SIG_DeliveredAPI_DeliveredSignaturesParameter.recipients,
    signatureStatus: SIG_DeliveredAPI_DeliveredSignaturesParameter.signatureStatus,
    expiryDate: SIG_DeliveredAPI_DeliveredSignaturesParameter.expiryDate,
    LastReminderDate: SIG_DeliveredAPI_DeliveredSignaturesParameter.lastReminderDate,
    deliveredDate: SIG_DeliveredAPI_DeliveredSignaturesParameter.deliveredDate,
    locationId: SIG_DeliveredAPI_DeliveredSignaturesParameter.locationId
  }
}

export const getSignerDetailsRequestParameter: commonDocumentIdQueryRequestParameter = {
  documentIdQuery: SIG_DeliveredAPI_SignerDetailsParameter.documentIdQuery
}

export const getAccessLinkRequestParameter: commonDocumentIdQueryRequestParameter = {
  ...getSignerDetailsRequestParameter
}

export const getSignatureStatusRequestParameter: commonDocumentIdQueryRequestParameter = {
  ...getSignerDetailsRequestParameter
}

export const getAccessLinkResponseBody: GetAccessLinkResponseBody = {
  ...baseResponseBody,
  data: {
    accessLink: SIG_DeliveredAPI_AccessLinkParameter.accessLink,
    emailAddress: SIG_DeliveredAPI_AccessLinkParameter.signerInfoEmailAddress,
    signedOn: SIG_DeliveredAPI_AccessLinkParameter.signerInfoSignedOn,
    isSigned: SIG_DeliveredAPI_AccessLinkParameter.signerInfoIsSigned,
    clientType: SIG_DeliveredAPI_AccessLinkParameter.signerInfoClientType,
    clientGuid: SIG_DeliveredAPI_AccessLinkParameter.signerInfoClientGuid
  }
}

export const getSignerDetailRequestParameter: GetSignerDetailRequestParameter = {
  documentIdQuery: SIG_ArchivedSignatures_SignerDetailsParameter.documentIdQuery
}

export const getSignerDetailsResponseBody: GetSignerDetailsResponseBody = {
  ...baseResponseBody,
  data: {
    recipientsEmailAddress: SIG_ArchivedSignatures_SignerDetailsParameter.recipientsEmailAddress,
    recipientsSignedOn: SIG_ArchivedSignatures_SignerDetailsParameter.recipientsSignedOn,
    recipientsIisSigned: SIG_ArchivedSignatures_SignerDetailsParameter.recipientsIsSigned,
    recipientsClientType: SIG_ArchivedSignatures_SignerDetailsParameter.recipientsClientType,
    recipientsClientGuid: SIG_ArchivedSignatures_SignerDetailsParameter.recipientsClientGuid,
    delegateeEmailAddress: SIG_ArchivedSignatures_SignerDetailsParameter.delegateeEmailAddress,
    delegateeSignedOn: SIG_ArchivedSignatures_SignerDetailsParameter.delegateeSignedOn,
    delegateeIsSigned: SIG_ArchivedSignatures_SignerDetailsParameter.delegateeIsSigned,
    delegateeClientType: SIG_ArchivedSignatures_SignerDetailsParameter.delegateeClientType,
    delegateeClientGuid: SIG_ArchivedSignatures_SignerDetailsParameter.delegateeClientGuid,
    senderEmailAddress: SIG_ArchivedSignatures_SignerDetailsParameter.senderEmailAddress,
    senderSignedOn: SIG_ArchivedSignatures_SignerDetailsParameter.senderSignedOn,
    senderIsSigned: SIG_ArchivedSignatures_SignerDetailsParameter.senderIsSigned,
    senderClientType: SIG_ArchivedSignatures_SignerDetailsParameter.senderClientType,
    senderClientGuid: SIG_ArchivedSignatures_SignerDetailsParameter.senderClientGuid
  }
}

export const SIG_Archived_GetAccessLinkResponseBody: SIG_ARCHIVED_GetAccessLinkResponseBody = {
  ...baseResponseBody,
  data: {
    accessLink: SIG_ArchivedSignatures_GetAccessLinkParameter.accessLink,
    emailAddress: SIG_ArchivedSignatures_GetAccessLinkParameter.emailAddress,
    signedOn: SIG_ArchivedSignatures_GetAccessLinkParameter.signedOn,
    isSigned: SIG_ArchivedSignatures_GetAccessLinkParameter.isSigned,
    clientType: SIG_ArchivedSignatures_GetAccessLinkParameter.clientType,
    clientGuid: SIG_ArchivedSignatures_GetAccessLinkParameter.clientGuid
  }
}

export const archivedAPIresendAccessLinkRequestBody: ArchivedAPIresendAccessLinkRequestBody = {
  requiredDocumentId: sigBaseRequestBodyParameter.requiredDocumentId,
  requiredCorrelationId: sigBaseRequestBodyParameter.requiredCorrelationID,
  requiredClientGuid: sigBaseRequestBodyParameter.requiredClientGuid
}

export const getArchivedSignatureRequestParameter: GetArchivedSignatureRequestParameter = {
  clientIdQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.clientIdQuery,
  clientNameQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.clientNameQuery,
  subjectQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.subjectQuery,
  sentByQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.sentByQuery,
  documentNameQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.documentNameQuery,
  documentTypeQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.documentTypeQuery,
  taxYearQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.taxYearQuery,
  deliveredDateQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.deliveredDateQuery,
  recipientQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.recipientQuery,
  signatureStatusQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.signatureStatusQuery,
  expiryDateQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.expiryDateQuery,
  archivedDateQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.archivedDateQuery,
  lastReminderDateQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.lastReminderDateQuery,
  sortByQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.sortByQuery,
  sortOrderQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.sortOrderQuery,
  pageSizeQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.pageSizeQuery,
  pageNumberQuery: SIG_ArchivedSignatures_ArchivedSignaturesParameter.pageNumberQuery
}
export const SIG_Archived_GetAccessLinkRequestParameter: SIG_ARCHIVED_GetAccessLinkRequestParameter = {
  documentIdQuery: SIG_ArchivedSignatures_GetAccessLinkParameter.documentIdQuery
}


export const getArchivedSignatureResponseBody: GetArchivedSignatureResponseBody = {
  ...baseResponseBody,
  data: {
    clientId: SIG_ArchivedSignatures_ArchivedSignaturesParameter.clientId,
    clientName: SIG_ArchivedSignatures_ArchivedSignaturesParameter.clientName,
    subject: SIG_ArchivedSignatures_ArchivedSignaturesParameter.subject,
    sentBy: SIG_ArchivedSignatures_ArchivedSignaturesParameter.sentBy,
    documentId: SIG_ArchivedSignatures_ArchivedSignaturesParameter.documentId,
    documentName: SIG_ArchivedSignatures_ArchivedSignaturesParameter.documentName,
    documentType: SIG_ArchivedSignatures_ArchivedSignaturesParameter.documentType,
    expiresOn: SIG_ArchivedSignatures_ArchivedSignaturesParameter.expiresOn,
    taxYear: SIG_ArchivedSignatures_ArchivedSignaturesParameter.taxYear,
    recipients: SIG_ArchivedSignatures_ArchivedSignaturesParameter.recipients,
    signatureStatus: SIG_ArchivedSignatures_ArchivedSignaturesParameter.signatureStatus,
    expiryDate: SIG_ArchivedSignatures_ArchivedSignaturesParameter.expiryDate,
    lastReminderDate: SIG_ArchivedSignatures_ArchivedSignaturesParameter.lastReminderDate,
    deliveredDate: SIG_ArchivedSignatures_ArchivedSignaturesParameter.deliveredDate,
    archivedDate: SIG_ArchivedSignatures_ArchivedSignaturesParameter.archivedDate,
    locationId: SIG_ArchivedSignatures_ArchivedSignaturesParameter.locationId
  }
}

export const getRecycleBinResponseBody: GetRecycleBinResponseBody = {
  ...baseResponseBody,
  data: {
    clientName: SIG_RecycleBinApi_RecycleBinSignatureParameter.clientName,
    clientId: SIG_RecycleBinApi_RecycleBinSignatureParameter.clientId,
    subject: SIG_RecycleBinApi_RecycleBinSignatureParameter.subject,
    SignatureDocumentType: SIG_RecycleBinApi_RecycleBinSignatureParameter.SignatureDocumentType,
    taxYear: SIG_RecycleBinApi_RecycleBinSignatureParameter.taxYear,
    deletedBy: SIG_RecycleBinApi_RecycleBinSignatureParameter.deletedBy,
    signatureStatus: SIG_RecycleBinApi_RecycleBinSignatureParameter.signatureStatus,
    documentId: SIG_ArchivedSignatures_ArchivedSignaturesParameter.documentId,
    documentName: SIG_ArchivedSignatures_ArchivedSignaturesParameter.documentName,
    documentType: SIG_ArchivedSignatures_ArchivedSignaturesParameter.documentType,
    expiresOn: SIG_ArchivedSignatures_ArchivedSignaturesParameter.expiresOn,
    recipients: SIG_RecycleBinApi_RecycleBinSignatureParameter.recipients,
    deletionDate: SIG_RecycleBinApi_RecycleBinSignatureParameter.deletionDate,
    locationId: SIG_RecycleBinApi_RecycleBinSignatureParameter.locationId,
  }
}

export const sendForSignatureRequestBody: SendForSignatureRequestBody = {
  documentName: SIG_UploadApi_SendForSignatureParameter.documentName,
  document: SIG_UploadApi_SendForSignatureParameter.document,
  clientId: SIG_UploadApi_SendForSignatureParameter.clientId,
  clientName: SIG_UploadApi_SendForSignatureParameter.clientName,
  taxYear: SIG_UploadApi_SendForSignatureParameter.taxYear,
  DocumentType: SIG_UploadApi_SendForSignatureParameter.documentType,
  expiresOn: SIG_UploadApi_SendForSignatureParameter.expiresOn,
  pageNo: SIG_UploadApi_SendForSignatureParameter.senderSignatureInfoPageNo,
  signatureControlsType: SIG_UploadApi_SendForSignatureParameter.senderSignatureInfoSignatureControlsType,
  signatureControlsTop: SIG_UploadApi_SendForSignatureParameter.senderSignatureInfoSignatureControlsTop,
  signatureControlsLeft: SIG_UploadApi_SendForSignatureParameter.senderSignatureInfoSignatureControlsLeft,
  signatureControlsRequired: SIG_UploadApi_SendForSignatureParameter.senderSignatureInfoSignatureControlsRequired,
  signatureControlsTooltip: SIG_UploadApi_SendForSignatureParameter.senderSignatureInfoSignatureControlsTooltip,
  senderSignOption: SIG_UploadApi_SendForSignatureParameter.senderSignOption,
  recipientsSignatureInfoEmailAddress: SIG_UploadApi_SendForSignatureParameter.recipientsSignatureInfoEmailAddress,
  signatureDataListPageNo: SIG_UploadApi_SendForSignatureParameter.recipientsSignatureInfoSignatureDataListPageNo,
  signatureDataListSignatureControlsType: SIG_UploadApi_SendForSignatureParameter.recipientsSignatureInfoSignatureDataListSignatureControlsType,
  signatureDataListSignatureControlsTop: SIG_UploadApi_SendForSignatureParameter.recipientsSignatureInfoSignatureDataListSignatureControlsTop,
  signatureDataListSignatureControlsLeft: SIG_UploadApi_SendForSignatureParameter.recipientsSignatureInfoSignatureDataListSignatureControlsLeft,
  signatureDataListSignatureControlsRequired: SIG_UploadApi_SendForSignatureParameter.recipientsSignatureInfoSignatureDataListSignatureControlsRequired,
  signatureDataListSignatureControlsTooltip: SIG_UploadApi_SendForSignatureParameter.recipientsSignatureInfoSignatureDataListSignatureControlsTooltip,
  isAccessCodeRequired: SIG_UploadApi_SendForSignatureParameter.isAccessCodeRequired,
  callBackUri: SIG_UploadApi_SendForSignatureParameter.callBackUri,
  correlationId: SIG_UploadApi_SendForSignatureParameter.correlationId,
}

export const sendForSignatureWithTextIdRequestBody: SendForSignatureWithTextIdRequestBody = {
  correlationId: SIG_UploadApi_SendForSignature_WithTextIdParameter.correlationId,
  documentName: SIG_UploadApi_SendForSignature_WithTextIdParameter.documentName,
  document: SIG_UploadApi_SendForSignature_WithTextIdParameter.document,
  clientId: SIG_UploadApi_SendForSignature_WithTextIdParameter.clientId,
  clientName: SIG_UploadApi_SendForSignature_WithTextIdParameter.clientName,
  taxYear: SIG_UploadApi_SendForSignature_WithTextIdParameter.taxYear,
  DocumentType: SIG_UploadApi_SendForSignature_WithTextIdParameter.documentType,
  expiresOn: SIG_UploadApi_SendForSignature_WithTextIdParameter.expiresOn,
  senderSignOption: SIG_UploadApi_SendForSignature_WithTextIdParameter.senderSignOption,
  callBackUri: SIG_UploadApi_SendForSignature_WithTextIdParameter.callBackUri,
  isAccessCodeRequired: SIG_UploadApi_SendForSignature_WithTextIdParameter.isAccessCodeRequired,
  recipientsSignatureInfoEmailAddress: SIG_UploadApi_SendForSignature_WithTextIdParameter.recipientSignatureInfoEmailAddress,
  recipientSignatureInfoControlsTextId: SIG_UploadApi_SendForSignature_WithTextIdParameter.recipientSignatureInfoControlsTextId,
  recipientSignatureInfoControlsIsRequired: SIG_UploadApi_SendForSignature_WithTextIdParameter.recipientSignatureInfoControlsIsRequired,
  recipientSignatureInfoControlsToolTip: SIG_UploadApi_SendForSignature_WithTextIdParameter.recipientSignatureInfoControlsToolTip,
  senderSignatureInfoTextId: SIG_UploadApi_SendForSignature_WithTextIdParameter.senderSignatureInfoTextId,
  senderSignatureInfoIsRequired: SIG_UploadApi_SendForSignature_WithTextIdParameter.senderSignatureInfoIsRequired,
  senderSignatureInfoToolTip: SIG_UploadApi_SendForSignature_WithTextIdParameter.senderSignatureInfoToolTip
}

export const getSignatureStatusResponseBody: GetSignatureStatusResponseBody = {
  ...baseResponseBody,
  data: {
    clientName: SIG_UploadApi_SignatureStatusParameter.clientName,
    clientId: SIG_UploadApi_SignatureStatusParameter.clientId,
    sentBy: SIG_UploadApi_SignatureStatusParameter.sentBy,
    documentName: SIG_UploadApi_SignatureStatusParameter.documentName,
    documentType: SIG_UploadApi_SignatureStatusParameter.documentType,
    taxYear: SIG_UploadApi_SignatureStatusParameter.taxyear,
    deliveredDate: SIG_UploadApi_SignatureStatusParameter.deliveredDate,
    expiryDate: SIG_UploadApi_SignatureStatusParameter.expiryDate,
    lastReminderDate: SIG_UploadApi_SignatureStatusParameter.lastReminderDate,
    isArchived: SIG_UploadApi_SignatureStatusParameter.isArchived,
    documentId: SIG_UploadApi_SignatureStatusParameter.documentId,
    recipientSignInfoEmailAddress: SIG_UploadApi_SignatureStatusParameter.emailAddress,
    recipientSignInfoIsSigned: SIG_UploadApi_SignatureStatusParameter.isSigned,
    recipientSignInfoSignedOn: SIG_UploadApi_SignatureStatusParameter.signedOn
  }
}

export const signatureStatusRequestBody: SignatureStatusRequestBody = {
  signingId: SIG_StatusApi_SignatureStatusParameter.signingId,
  correlationId: SIG_StatusApi_SignatureStatusParameter.correlationId,
  documentId: SIG_StatusApi_SignatureStatusParameter.documentId,
}